import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Alert, Box, Button } from "@mui/material";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import { adminLibraryManagedByLibrarian } from "../utils/staffRoles";
import { getSchoolIdForUser } from "../utils/userContext";
import LibraryAnalyticsPanel from "./library/LibraryAnalyticsPanel";

/**
 * When a librarian is appointed, the director sees analytics only (not full inventory CRUD).
 */
export default function LibraryAdminOnly({ children }) {
    const { currentUser } = useSelector((state) => state.user);
    const { teachersList } = useSelector((state) => state.teacher);
    const managedByLibrarian = adminLibraryManagedByLibrarian(currentUser, teachersList, {
        requireProfileCompleted: true,
    });
    const schoolId = getSchoolIdForUser(currentUser);

    if (!managedByLibrarian) {
        return children;
    }

    return (
        <Box>
            <Alert severity="info" sx={{ mx: { xs: 2, sm: 3 }, mt: 2, borderRadius: 2 }}>
                Your librarian manages books, TLMs, and borrowing in their portal. As director, review library
                performance under <strong>Advanced analytics</strong> below or on the analytics page.
            </Alert>
            <Box sx={{ px: { xs: 2, sm: 3 }, pt: 2, pb: 1 }}>
                <Button
                    component={Link}
                    to="/Admin/analytics"
                    variant="outlined"
                    size="small"
                    startIcon={<InsightsOutlinedIcon />}
                >
                    Open advanced analytics
                </Button>
            </Box>
            <Box sx={{ px: { xs: 2, sm: 3 }, pb: 3 }}>
                <LibraryAnalyticsPanel schoolId={schoolId} />
            </Box>
        </Box>
    );
}
